import { render, staticRenderFns } from "./veStuAttendEdit.vue?vue&type=template&id=67b674d8&scoped=true"
import script from "./veStuAttendEdit.vue?vue&type=script&lang=js"
export * from "./veStuAttendEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b674d8",
  null
  
)

export default component.exports